import ViewAccordion from './ViewAccordion';

export default ViewAccordion;
